import { render } from "./BasePlannerExam.vue?vue&type=template&id=468c1322"
import script from "./BasePlannerExam.vue?vue&type=script&lang=js"
export * from "./BasePlannerExam.vue?vue&type=script&lang=js"

import "./BasePlannerExam.vue?vue&type=style&index=0&id=468c1322&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__